<template>
  <div>
    <b-breadcrumb :items="items"></b-breadcrumb>
    <div
      v-if="busy"
      class="text-center"
      style="
        position: fixed;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
        z-index: 10000;
      "
    >
      <b-spinner label="Spinning"></b-spinner>
    </div>
    <b-row class="mx-0 mb-3">
      <b-col>
        <b-card class="bg-light shadow">
          <b-card-title title-tag="h6">
            Débiteurs
            <span v-if="resultsInfo">({{ resultsInfo }} résultats)</span>
          </b-card-title>
          <div class="d-flex justify-content-start align-items-center">
            <b-button
              @click="openNewDebtorDialog()"
              variant="success"
              size="sm"
            >
              <b-icon-plus-circle-fill class="mr-1"></b-icon-plus-circle-fill>
              Nouveau débiteur
            </b-button>
            <label class="mx-3 align-self-center">Rechercher : </label>
            <mh-input
              @enter="submitSearch(searchTable.search.value, 'all')"
              autofocus
              append="🔍"
              field="search"
              :table="searchTable"
              :autocomplete="{
                field: 'debiteur.nom_soc || debiteur.(nom prenom)',
              }"
            >
            </mh-input>
            <label class="mx-3 align-self-center">Par numéro : </label>
            <mh-input
              @enter="submitSearch(searchTable.byID.value, 'ID')"
              append="🔍"
              field="byID"
              :table="searchTable"
              :autocomplete="{
                idHistory: 'debtors',
                field: 'debiteur.ID',
              }"
            ></mh-input>
          </div>

          <b-row v-if="$options.debtors.length > 0" class="mt-3">
            <b-col sm="12" md="12" lg="12">
              <list
                @changePage="changePage"
                @removeFilter="removeFilter"
                @changeSort="changeSort"
                :fields="fields"
                :search="search"
                :filters="filters"
                :items="$options.debtors"
              >
                <template v-slot:cell(ID)="data">
                  <router-link
                    :to="{
                      name: 'debtorView',
                      params: { id: data.item.ID },
                    }"
                    >{{ data.item.ID }}</router-link
                  >
                </template>
                <template v-slot:cell(nom_soc)="data">
                  <router-link
                    :to="{
                      name: 'debtorView',
                      params: { id: data.item.ID },
                    }"
                    ><template v-if="company(data.item.nom_soc)">
                      <span v-html="company(data.item.nom_soc)"></span>
                    </template>
                    <template v-else>
                      <span
                        v-html="fullName(data.item.prenom, data.item.nom)"
                      ></span>
                    </template>
                  </router-link>
                </template>

                <template v-slot:cell(address)="data">
                  <span v-html="data.item.rue1 + ' ' + data.item.rue2"></span>
                  <span
                    v-html="
                      data.item.codepostal + ' ' + ucfirst(data.item.localite)
                    "
                  ></span>
                </template>
                <template v-slot:cell(mail)="data">
                  <span
                    v-for="(mail, index) in data.item.email.split(';')"
                    :key="index"
                  >
                    <b-link
                      class="mr-2"
                      active
                      target="_blank"
                      :href="'mailto:' + mail"
                    >
                      <span v-html="mail.toLowerCase()"></span>
                    </b-link>
                  </span>
                </template>
                <template v-slot:cell(humDate)="data">{{
                  toDate(data.item.date_creation)
                }}</template>
                <template v-slot:cell(actions)="data">
                  <b-button v-if="nextUnusedWarrant" variant="success" title="Ouvrir un mandat" @click="openWarrant(data.item.ID)" size="sm" class="btn-xs" icon>
                    <b-icon icon="file-earmark-text"></b-icon>
                  </b-button>  
                </template>
              </list>
            </b-col>
          </b-row>
          <b-row v-else-if="loaded" class="mt-3">
            <b-col lg="12">
              <b-alert show>Pas de résultats</b-alert>
            </b-col>
          </b-row>
        </b-card>
      </b-col>
    </b-row>
    <b-modal
      size="lg"
      title="Nouveau débiteur"
      id="new-debtor"
      hide-footer
      title-class="text-center"
    >
      <b-row :key="render">
        <mh-input
          mh-class="col-12"
          labelColsLg="0"
          autofocus
          field="type"
          @change="reinitForm()"
          :table="debtor"
        ></mh-input>
        <template v-if="debtor.type.value == 'morale'">
          <mh-input
            mh-class="col-6"
            labelColsLg="0"
            field="nom_soc"
            :table="debtor"
          ></mh-input>
          <mh-input
            mh-class="col-6"
            labelColsLg="0"
            field="langue"
            :table="debtor"
          ></mh-input>
          <mh-input
            mh-class="col-12"
            labelColsLg="0"
            field="rue1"
            :table="debtor"
            debounce="400"
            :autocomplete="{ field: 'google.places' }"
            @enter="suggestAddress($event)"
          ></mh-input>
          <mh-input
            mh-class="col-12"
            labelColsLg="0"
            field="rue2"
            :table="debtor"
          ></mh-input>
          <mh-input
            mh-class="col-4"
            labelColsLg="0"
            field="localite"
            :table="debtor"
          ></mh-input>
          <mh-input
            mh-class="col-4"
            labelColsLg="0"
            field="codepostal"
            :table="debtor"
          ></mh-input>
          <mh-input
            mh-class="col-4"
            labelColsLg="0"
            field="pays"
            :table="debtor"
          ></mh-input>
          <mh-input
            mh-class="col-6"
            labelColsLg="0"
            field="telephone"
            :table="debtor"
          ></mh-input>
          <mh-input
            mh-class="col-6"
            labelColsLg="0"
            field="gsm"
            :table="debtor"
          ></mh-input>
          <mh-input
            mh-class="col-6"
            labelColsLg="0"
            field="tva"
            :table="debtor"
          ></mh-input>
          <mh-input
            mh-class="col-6"
            labelColsLg="0"
            field="email"
            :table="debtor"
          ></mh-input>
          <mh-input
            mh-class="col-12"
            labelColsLg="0"
            field="url"
            :table="debtor"
          ></mh-input>
          <mh-input
            mh-class="col-3"
            labelColsLg="0"
            field="titredebiteurID"
            :table="debtor"
          ></mh-input>
          <mh-input
            mh-class="col-3"
            labelColsLg="0"
            field="nom"
            :table="debtor"
          ></mh-input>
          <mh-input
            mh-class="col-3"
            labelColsLg="0"
            field="prenom"
            :table="debtor"
          ></mh-input>
          <mh-input
            mh-class="col-3"
            labelColsLg="0"
            field="sexe"
            :table="debtor"
          ></mh-input>
        </template>
        <template v-else>
          <mh-input
            mh-class="col-3"
            labelColsLg="0"
            field="titredebiteurID"
            :table="debtor"
          ></mh-input>
          <mh-input
            mh-class="col-3"
            labelColsLg="0"
            field="nom"
            :table="debtor"
          ></mh-input>
          <mh-input
            mh-class="col-3"
            labelColsLg="0"
            field="prenom"
            :table="debtor"
          ></mh-input>
          <mh-input
            mh-class="col-3"
            labelColsLg="0"
            field="sexe"
            :table="debtor"
          ></mh-input>
          <mh-input
            mh-class="col-6"
            labelColsLg="0"
            field="langue"
            :table="debtor"
          ></mh-input>
          <mh-input
            mh-class="col-6"
            labelColsLg="0"
            field="date_naissance"
            :table="debtor"
          ></mh-input>
          <mh-input
            mh-class="col-12"
            labelColsLg="0"
            field="rue1"
            :table="debtor"
            debounce="400"
            :autocomplete="{ field: 'google.places' }"
            @enter="suggestAddress($event)"
          ></mh-input>
          <mh-input
            mh-class="col-12"
            labelColsLg="0"
            field="rue2"
            :table="debtor"
          ></mh-input>
          <mh-input
            mh-class="col-4"
            labelColsLg="0"
            field="localite"
            :table="debtor"
          ></mh-input>
          <mh-input
            mh-class="col-4"
            labelColsLg="0"
            field="codepostal"
            :table="debtor"
          ></mh-input>
          <mh-input
            mh-class="col-4"
            labelColsLg="0"
            field="pays"
            :table="debtor"
          ></mh-input>
          <mh-input
            mh-class="col-6"
            labelColsLg="0"
            field="telephone"
            :table="debtor"
          ></mh-input>
          <mh-input
            mh-class="col-6"
            labelColsLg="0"
            field="gsm"
            :table="debtor"
          ></mh-input>

          <mh-input
            mh-class="col-6"
            labelColsLg="0"
            field="email"
            :table="debtor"
          ></mh-input>
        </template>
      </b-row>
      <hr class="mt-3" />
      <div class="text-right">
        <b-button variant="success" size="sm" @click="save()"
          >Créer le débiteur</b-button
        >
        <b-button
          variant="danger"
          class="ml-2"
          size="sm"
          @click="$bvModal.hide('new-debtor')"
          >Annuler</b-button
        >
      </div>
    </b-modal>
  </div>
</template>

<script>
import List from "@/components/List";
//import Facets from "@/components/Facets";
import creditors from "@/services/creditors.js";
import debtors from "@/services/debtors.js";
import DateTime from "@/services/DateTime.js";
import String from "@/services/String.js";
import MhInput from "@/components/MhInput.vue";

export default {
  components: {
    List,
    MhInput,
  },
  name: "Debtors",
  debtors: [],
  data() {
    return {
      nextUnusedWarrant: false,
      totalUnusedWarrants: 0,
      searchTable: {
        search: {
          label: "",
          type: "varchar",
          value: "",
        },
        byID: {
          label: "",
          type: "int",
          value: "",
        },
      },
      render: 0,
      debtor: {
        type: {
          label: "Type de débiteur",
          type: "enum",
          value: "morale",
          options: [
            {
              value: "morale",
              text: "Personne morale",
            },
            {
              value: "physique",
              text: "Personne physique",
            },
          ],
        },
        nom_soc: {
          label: "Nom de société",
          type: "varchar",
          value: "",
        },
        langue: {
          label: "Langue",
          type: "enum",
          value: "Fr",
          options: [
            {
              value: "Fr",
              text: "Français",
            },
            {
              value: "Nl",
              text: "Néerlandais",
            },
            {
              value: "En",
              text: "Anglais",
            },
            {
              value: "All",
              text: "Allemand",
            },
          ],
        },
        rue1: {
          label: "Adresse",
          type: "varchar",
          value: "",
        },
        rue2: {
          label: "",
          type: "varchar",
          value: "",
        },
        localite: {
          label: "Localité",
          type: "varchar",
          value: "",
        },
        codepostal: {
          label: "Code postal",
          type: "varchar",
          value: "",
        },
        pays: {
          label: "Pays",
          type: "varchar",
          value: "",
        },
        telephone: {
          label: "Téléphone",
          type: "varchar",
          value: "",
        },
        gsm: {
          label: "GSM",
          type: "varchar",
          value: "",
        },
        tva: {
          label: "TVA",
          type: "varchar",
          value: "",
        },
        email: {
          label: "Adresse email",
          type: "varchar",
          value: "",
        },
        url: {
          label: "Site Web",
          type: "varchar",
          value: "",
        },
        titredebiteurID: {
          label: "Titre",
          type: "enum",
          value: 1,
          options: [
            {
              value: 1,
              text: "Monsieur",
            },
            {
              value: 2,
              text: "Madame",
            },
            {
              value: 3,
              text: "Docteur",
            },
            {
              value: 4,
              text: "Messieurs",
            },
            {
              value: 5,
              text: "Madame, Monsieur",
            },
            {
              value: 6,
              text: "Mademoiselle",
            },
            {
              value: 7,
              text: "Maître",
            },
          ],
        },
        nom: {
          label: "Nom",
          type: "varchar",
          value: "",
        },
        prenom: {
          label: "Prénom",
          type: "varchar",
          value: "",
        },
        sexe: {
          label: "Sexe",
          type: "enum",
          value: "M",
          options: [
            {
              value: "M",
              text: "M",
            },
            {
              value: "F",
              text: "F",
            },
          ],
        },
        date_naissance: {
          label: "Date de naissance",
          type: "date",
          value: null,
        },
      },
      debug: false,
      info: {},
      search: this.$route.query.search,
      facets: [],
      filters: [],
      page: 1,
      pagination: {},
      loaded: false,
      resultsInfo: false,
      sortBy: "lastUpdate",
      sortDesc: true,
      busy: false,
      actions: [],
      items: [
        {
          text: "Gestion",
          to: { name: "home" },
        },
        {
          text: "Débiteurs",
          active: true,
        },
      ],
      fields: [
        {
          key: "ID",
          label: "#",
          thStyle: "width:100px",
          class: "text-right",
          sortable: true,
        },
        { key: "nom_soc", label: "Nom", sortable: true, thStyle: { width: "15%" }, },

        {
          key: "address",
          label: "Adresse",
          sortable: true,
          class: "text-left",
        },
        {
          key: "telephone",
          label: "Téléphone",
          sortable: false,
          thStyle: { width: "5%" },
        },
        { key: "mail", label: "Email", sortable: true },
        {
          key: "humDate",
          label: "Date",
          sortable: true,

          thStyle: { width: "5%" },
        },
        {
          key: "actions",
          label:"Actions",
          class: "text-center",
          thStyle: { width: "5%"}
        }
      ],
    };
  },
  created() {
    this.search = this.$route.params.search || "";
    this.scroll();
    this.submitSearch(this.search, "all");
    creditors.nextUnusedWarrant().then((response) => {
      if (response.data.id) {
        this.nextUnusedWarrant = response.data.id;
        this.totalUnusedWarrants = response.data.total;
      }
    });
  },

  computed: {
    export_ra() {
      let url = this.$store.getters.url + "/debtors/ra/export?";
      url += "token=" + encodeURIComponent(localStorage.getItem("vue-token"));
      return url;
    },
  },
  methods: {
    scroll() {
      window.onscroll = () => {
        let bottomOfWindow =
          document.documentElement.scrollTop + window.innerHeight + 300 >
          document.documentElement.offsetHeight;
        if (
          bottomOfWindow &&
          this.pagination.numberOfPages > this.page &&
          !this.busy
        ) {
          this.page++;
          this.continueSearch();
        }
      };
    },
    openWarrant(debiteurID) {
      this.$router.push({ name: "warrantOpen",  params: { id: this.nextUnusedWarrant, debiteur: debiteurID}})
    },
    suggestAddress(payload) {
      this.debtor.rue1.value = payload.route || "";
      if (payload.street_number) {
        this.debtor.rue1.value += ", " + payload.street_number;
      }
      this.debtor.rue2.value = "";
      this.debtor.localite.value = payload.city || "";
      this.debtor.pays.value = payload.country || "";
      this.debtor.codepostal.value = payload.postal_code || "";
    },
    fullName(a, b) {
      return String.fullName(a, b);
    },
    ucfirst(a) {
      return String.ucfirst(a);
    },
    company(a) {
      return String.company(a);
    },
    toDate(d) {
      return DateTime.humanDate(d);
    },
    reinit() {
      this.page = 1;
      this.filters = [];
      return true;
    },
    changeSort(ctx) {
      this.sortBy = ctx.sortBy;
      this.sortDesc = ctx.sortDesc;
      this.submitSearch();
    },
    changePage(page) {
      this.page = page;
      this.submitSearch();
    },
    removeFilter(index) {
      this.filters.splice(index, 1);
      this.submitSearch();
    },
    narrow(object) {
      this.filters.push(object);
      this.submitSearch();
    },
    openNewDebtorDialog() {
      this.$bvModal.show("new-debtor");
    },
    reinitForm() {
      for (let el in this.debtor) {
        if (typeof this.debtor[el] == "object") {
          this.debtor[el].error = false;
        }
      }
      this.render++;
    },
    save() {
      this.busy = true;
      debtors.post(this.debtor).then((response) => {
        if (response.data.success) {
          this.$bvToast.toast("Débiteur enregistré", {
            title: `Recuperator`,
            toaster: "b-toaster-top-right",
            variant: "success",
            autoHideDelay: 2000,
            solid: false,
          });

          for (let el in this.debtor) {
            if (typeof this.debtor[el] == "object") {
              this.debtor[el].error = false;
            }
          }
          this.render++;
          this.busy = false;
          this.$bvModal.hide("new-debtor");
          this.searchTable.byID.value = response.data.id;
          this.submitSearch(this.searchTable.byID.value, "ID");
        } else if (response.data.fail) {
          for (let el in this.detbtor) {
            this.debtor[el].error = false;
          }
          response.data.fail.forEach((element) => {
            this.debtor[element.field].error = element.errors.join(" ; ");
          });
          this.busy = false;
          this.render++;
        } else if (response.data.error) {
          this.$bvToast.toast("Erreur : " + response.data.error, {
            title: `Recuperator`,
            toaster: "b-toaster-top-right",
            variant: "danger",
            autoHideDelay: 2000,
            solid: false,
          });
          this.busy = false;
        }
      });
    },
    continueSearch() {
      this.busy = true;
      debtors
        .search(
          this.search,
          this.field,
          this.filters,
          "",
          this.page,
          this.sortBy,
          this.sortDesc,
          this.activeCreditor
        )
        .then((response) => {
          this.$options.debtors = this.$options.debtors.concat(
            response.data.results.records
          );
          this.pagination = response.data.results.pagination;
          this.busy = false;
        })
        .catch(() => {
          this.loaded = true;
          this.busy = false;
        });
    },
    submitSearch(value = null, field = null) {
      this.busy = true;
      this.page = 1;
      this.filters = [];
      if (value !== null) {
        this.search = value;
      }
      if (field !== null) {
        this.field = field;
      }

      debtors
        .search(
          this.search,
          this.field,
          this.filters,
          "",
          this.page,
          this.sortBy,
          this.sortDesc
        )
        .then((response) => {
          this.$options.debtors = response.data.results.records;
          this.pagination = response.data.results.pagination;
          this.resultsInfo = this.pagination.totalRecords;
          this.loaded = true;
          this.busy = false;
        })
        .catch((error) => {
          console.error(error);
          this.loaded = true;
          this.busy = false;
        });
    },
  },
};
</script>

<style lang="scss" scoped>
</style>
